
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/sale",
      function () {
        return require("private-next-pages/category/sale.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/sale"])
      });
    }
  